import { useState } from 'react'
import PersonalInfoFormModal from './PersonalInfoFormModal'
import VehicleFormModal from './VehicleFormModal'
import ProposalSuccessModal from './ProposalSuccessModal'

interface SalvcarModalProps {
  onBack: () => void
}

type SalvcarStep = 'personalInfoForm' | 'vehicleForm' | 'success'

export default function SalvcarModal({ onBack }: SalvcarModalProps) {
  const [step, setStep] = useState<SalvcarStep>('personalInfoForm')

  switch (step) {
    case 'personalInfoForm':
      return (
        <PersonalInfoFormModal
          onBack={onBack}
          onContinue={() => setStep('vehicleForm')}
        />
      )
    case 'vehicleForm':
      return (
        <VehicleFormModal
          onBack={() => setStep('personalInfoForm')}
          onContinue={() => setStep('success')}
        />
      )
    case 'success':
      return <ProposalSuccessModal />
    default:
      return null
  }
}
